import * as React from 'react';
import { NodeViewWrapper, NodeViewProps, NodeViewContent } from '@tiptap/react';
import { Icon } from '@cotera/client/app/components';

export interface DisclaimerNodeViewProps extends NodeViewProps {
  node: NodeViewProps['node'] & {
    attrs: {
      text: string;
    };
  };
}

export const DisclaimerNodeView: React.FC<NodeViewProps> = () => {
  return (
    <NodeViewWrapper
      className="disclaimer-node react-renderer mt-4"
      contentEditable={true}
    >
      <div className="flex items-start gap-2 p-2 bg-emerald-50 border border-emerald-300 rounded-lg">
        {/* Icon */}
        <div className="flex-shrink-0 rounded-full flex items-center justify-center">
          <Icon icon="warning-circle" className="text-emerald-500 mt-1" />
        </div>

        <NodeViewContent className="content is-editable text-emerald-500" />
      </div>
    </NodeViewWrapper>
  );
};
